import { createContext, useContext } from "react"

import { type ExtendedCreator } from "@forento/core/models/user"

export type UserContextValue = {
	user?: ExtendedCreator
	isLoading: boolean
	error: unknown
	reload(options?: { clearSessionCache?: boolean }): Promise<void>
	signOut(): Promise<void>
}

const UserContext = createContext<UserContextValue>(undefined!)

export default UserContext

export const useUser = () => useContext(UserContext)

/**
 * Shortcut for `useUser().user.platform`
 */
export const usePlatform = () => useUser().user?.platform ?? null
